import { Component, ViewChild, OnInit } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AppSettings } from 'app/modules/shared/app.settings';
import { MiFormComponent } from 'app/modules/shared/components/mi-form/mi-form.component';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { Country } from 'app/modules/shared/models/country';
import { Language } from 'app/modules/shared/models/language';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { ConfigService } from 'app/modules/shared/services/config.service';
import { EntityService } from 'app/modules/shared/services/entity.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import * as _ from 'lodash';
import { MetaDataService } from 'app/modules/shared/services/meta-data.service';
@Component({
  selector: 'app-settings-general-management-settings',
  standalone: true,
  imports: [InputTextModule, FormsModule, ReactiveFormsModule, TranslateModule, ButtonModule, MiFormComponent, TabViewModule, ToastModule, AccessProviderDirective, InputNumberModule, InputGroupModule, InputGroupAddonModule],
  templateUrl: './settings-general-management-settings.component.html',
  styleUrl: './settings-general-management-settings.component.scss'
})
export class SettingsGeneralManagementSettingsComponent implements OnInit {
  @ViewChild(MiFormComponent) form: MiFormComponent;
  timeSettingsAttributeData: any;
  attributeLabels = {};
  country: Country;
  language: Language;
  previousBtnLabel: any = this.cs.getLabel('lbl_cancel');
  // generalSaveBtn: any = this.cs.getLabel('lbl_save');
  activeIndex = 0;
  attributeValues: any;
  entityId: any;
  showForm: boolean = false;
  settingsGeneralData: any;
  generalData: any;
  generalSettingEntityId: any;
  generalSettingsData: any;
  saveGeneralSettingsBtnLabel: any;
  generalSettingsEntityData: any;
  generalAttributeData: any;
  exportGeneralSettingsModuleName = AppSettings.ENTITY_TYPE.ORDER_GEN_SETT;
  prefixToAttachForButtonIdToUniquelyIdentifyButton = AppSettings.BUTTON_PREFIX
  timeZonesOptions: any[] = [];

  constructor(
    private configService: ConfigService,
    public cs: CommonBindingDataService,
    private messageService: MessageService,
    private entityService: EntityService,
    private metaDataService: MetaDataService,
    private fb: FormBuilder) { }

  ngOnInit() {
    this.updateButtonLabel();
    this.getOrderSettings();
    this.setAppSettings();

    this.setGeneralSettingsEntityData();
    this.getTimeZones();
  }

  setGeneralSettingsEntityData() {
    this.generalSettingsEntityData = {
      countryCode: this.country[0].countryCode,
      tenantCode: this.configService.getLoggedInTenantCode(),
      entityCode: AppSettings.ENTITY_TYPE.ORDER_GEN_SETT
    }
  }

  getOrderSettings() {
    this.entityService.getEntityDetailsByView(AppSettings.ENTITY_TYPE.ORDER_GEN_SETT, {}).subscribe({
      next: (response: any) => {
        this.entityId = response.entityId;
        this.getEntityDetails();
        this.updateButtonLabel();
      },
      error: () => {
        this.showForm = true;
      }
    })
  }

  updateButtonLabel() {
    this.saveGeneralSettingsBtnLabel = this.entityId
      ? this.cs.getLabel('settings.lbl_update_general_settings')
      : this.cs.getLabel('settings.lbl_save_general_settings');
  }

  getEntityDetails() {
    this.entityService.getSettingsEntity(this.entityId, AppSettings.ENTITY_TYPE.ORDER_GEN_SETT, AppSettings.VIEW_CODE.ADD_EDIT_VIEW).subscribe({
      next: (response: any) => {
        this.attributeValues = this.cs.getOrgAttributeValues(response);
        for (const [key, value] of Object.entries(this.attributeValues)) {
          if (key === 'time_zone') {
            this.metaDataService.selectedTimezoneSubject.next(value);
          }
        }
        // Call getAttributesForGeneralOrderSetting after attributeValues is populated
        if (this.timeZonesOptions.length > 0) {
          this.getAttributesForGeneralOrderSetting();
        }
        this.showForm = true;
      },
      error: () => {
        this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel('error.errors.general[0].message') });
      }
    })
  }

  getAttributesForGeneralOrderSetting() {
    this.entityService.getAttributeDefinition(AppSettings.ENTITY_TYPE.ORDER_GEN_SETT, AppSettings.VIEW_CODE.ADD_EDIT_VIEW).subscribe(res => {
      if (res) {
        this.attributeLabels = this.cs.getAttributeLabels(res);
        this.generalData = this.cs.getOrganizedAttribute(res);
        const tab = this.generalData.tabs.find(ele => ele.tabCode === 'general');
        const generalTimeZoneGroup = tab?.groups.find(ele => ele.code === 'gen_order_sett');
        const timeZoneField = generalTimeZoneGroup?.fields.find(ele => ele.attributeCode === 'time_zone');

        if (timeZoneField) {
          timeZoneField.presetValues = this.timeZonesOptions;

          // Disable time_zone field if value is present
          if (this.attributeValues && this.attributeValues.time_zone) {
            timeZoneField.disabled = true;
          }
        }

        this.generalAttributeData = _.cloneDeep(this.generalData);
      }
    });
  }

  saveGeneralSettings(event) {
    const generalOrderManagementData = event;
    if (this.entityId) {
      this.generalSettingEntityId = this.entityId;
      this.saveOrderManagementData(this.generalSettingsEntityData.entityCode, generalOrderManagementData, false);
    } else {
      this.entityService.createEntities(this.generalSettingsEntityData.entityCode, this.generalSettingsEntityData).subscribe({
        next: (res: any) => {
          this.generalSettingEntityId = res.entityId;
          this.saveOrderManagementData(this.generalSettingsEntityData.entityCode, generalOrderManagementData, true);
        },
        error: () => {
          this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel('error.errors.general[0].message') });
        }
      });
    }
  }

  saveOrderManagementData(entityCode, generalOrderManagementData, isNewEntity) {
    this.settingsGeneralData = {
      forTenantCode: this.configService.getForTenantCode(),
      entityCode: AppSettings.ENTITY_TYPE.ORDER_GEN_SETT,
      countryCode: this.country[0].countryCode,
      languageCode: this.language[0].langCode,
      data: []
    };
    let timeZoneValue;
    for (const [key, value] of Object.entries(generalOrderManagementData)) {
      if (key === 'time_zone') {
        timeZoneValue = value;
      }
      const attributeValue = value;
      if (attributeValue) {
        this.settingsGeneralData.data.push({
          attributeCode: key,
          attributeValue
        });
      }
    }
    this.settingsGeneralData.data = this.cs.mapAttributeIds(this.settingsGeneralData.data, this.generalData.tabs);
    this.entityService.saveAttributeData(entityCode, this.generalSettingEntityId, this.settingsGeneralData).subscribe({
      next: () => {
        this.metaDataService.selectedTimezoneSubject.next(timeZoneValue);
        if (isNewEntity) {
          this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('settings.lbl_general_settings_saved_successfully') });
        } else {
          this.messageService.add({ key: 'tst', severity: 'success', summary: 'Success', detail: this.cs.getLabel('settings.lbl_general_settings_updated_successfully') });
        }
      },
      error: () => {
        this.messageService.add({ key: 'tst', severity: 'error', summary: 'Error', detail: this.cs.getLabel('error.errors.general[0].message') });
      }
    });
  }

  onCancel() {
    this.form.resetForm();
    this.attributeValues = null;
    if (this.entityId) {
      this.showForm = false;
      this.getEntityDetails();
    }
  }

  private setAppSettings() {
    this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    this.language = JSON.parse(localStorage.getItem(AppSettings.LANGUAGE));
  }

  onNextBtnClick() {
    const btn = document.getElementById('general');
    btn.click();
  }

  getTimeZones() {
    const requestBody = {
      forTenantCode: this.configService.getForTenantCode(),
    }
    this.entityService.getTimeZones(requestBody).subscribe({
      next: (result: any) => {
        result.forEach(element => {
          this.timeZonesOptions.push({
            labelKey: element.gmtOffset,
            labelValue: `${element.timezone} - (${element.gmtOffset}) - ${this.metaDataService.getTimezoneAbbreviation(element.timezone)}`,
            value: element.timezone
          })
        });
        this.timeZonesOptions.sort((a, b) => a.value.localeCompare(b.value))

        // Only call getAttributesForGeneralOrderSetting if no entityId (new settings)
        if (!this.entityId) {
          this.getAttributesForGeneralOrderSetting();
        }
      }
    })
  }

}

